/*
  desc: 这里是公共方法
*/
import router from '@/router'
import { Loading } from 'element-ui'
import _ from 'lodash'
import { geoCoordMap } from 'utils/constants'

let needLoadingRequestCount = 0
let loading
function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '玩命加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    loading.close()
  }
}

export default {
  // 路由跳转
  $go: function (page, params, isBack, query) {
    if (page === -1) {
      router.go(-1)
      return
    }
    let route = { name: page }
    if (page.indexOf('/') > -1) {
      route = { path: page }
    }
    if (params) { route.params = params }
    if (query) { route.query = query }
    if (isBack) {
      router.replace(route)
    } else {
      router.push(route)
    }
  },
  // loading显示
  $showFullScreenLoading: function () {
    if (needLoadingRequestCount === 0) {
      startLoading()
    }
    needLoadingRequestCount++
  },
  // loading关闭
  $tryHideFullScreenLoading: function () {
    if (needLoadingRequestCount <= 0) { return }
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
      _.debounce(tryCloseLoading, 300)()
    }
  },
  $convertData: function (data) {
    var res = []
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name]
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value)
        })
      }
    }
    return res
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js